import { BaseComponent } from '../../base-component';
import { shouldShowBounceLayer } from './activation-handler';
import { generateEventMergeId } from '../../_common/client/tracking';
import { notNullQuerySelector } from '../../_common/client/dom-helper';

export class BounceLayerComponent extends BaseComponent {
    public readonly rootSelector: string = '.js_pdp_bounce-layer';

    public async init(): Promise<void> {
        this.registerFt9BounceLayerEvent();
        if (this.getRootElement().getAttribute('data-is-external-call') === 'true') {
            notNullQuerySelector('html').addEventListener('mouseleave', event => this.handleMouseLeaveEvent(event));
        }
    }

    public async onHtmlLoaded(): Promise<unknown> {
        return;
    }

    private registerFt9BounceLayerEvent() {
        o_global.eventQBus.on('ft9.bouncelayer.open', () => this.showBounceLayer());
    }

    private handleMouseLeaveEvent(event: MouseEvent) {
        if (shouldShowBounceLayer(event)) {
            this.showBounceLayer();
        }
    }

    private showBounceLayer() {
        const eventMergeId = generateEventMergeId();
        const sheetContent = this.getRootElement().dataset.sheetContent;
        new o_global.pali.layerBuilder({
            content: sheetContent,
            createTrackingContext: false,
            closeCallback: () => this.trackBounceGateClosed(eventMergeId),
        }).open();
        this.trackBounceGate(eventMergeId);
        this.registerBenefitSlot(eventMergeId);
        this.registerReco(eventMergeId);
    }

    private registerBenefitSlot(eventMergeId: string) {
        o_global.eventQBus.emit('ft9.benefit.slotReady', {
            variationId: this.getRootElement().getAttribute('data-variation-id'),
            productId: this.getRootElement().getAttribute('data-product-id'),
            targetElement: this.notNullQuerySelector('[data-cpgn-slot="bounce"]'),
            slotId: 'bounce',
            eventMergeId,
        });
    }

    private registerReco(eventMergeId: string) {
        window.o_reco?.api.loadBounceLayerCinema({
            target: '.js_pdp_bounceLayerCinema',
            variationId: this.getVariationId(),
            eventMergeId,
        });
    }

    private trackBounceGate(eventMergeId: string) {
        this.trackAddToEvent({ product_BounceGate: 'view' }, 'automatic', eventMergeId);
    }

    private trackBounceGateClosed(eventMergeId: string) {
        this.trackAddToEvent({ product_BounceGate: 'close' }, 'click', eventMergeId);
    }
}
